import { render, staticRenderFns } from "./FeeManagement.vue?vue&type=template&id=45f6496e&scoped=true"
import script from "./FeeManagement.vue?vue&type=script&lang=js"
export * from "./FeeManagement.vue?vue&type=script&lang=js"
import style0 from "./FeeManagement.vue?vue&type=style&index=0&id=45f6496e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f6496e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f6496e')) {
      api.createRecord('45f6496e', component.options)
    } else {
      api.reload('45f6496e', component.options)
    }
    module.hot.accept("./FeeManagement.vue?vue&type=template&id=45f6496e&scoped=true", function () {
      api.rerender('45f6496e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/FeeManagement.vue"
export default component.exports